import { TableRow, TableCell } from "@/components/ui/table";
import { FC } from "react";

interface TableEmptyRowProps {
	colSpan: number;
	text?: string;
	className?: string;
	rowclassName?: string;
}

export const TableEmptyRow: FC<TableEmptyRowProps> = ({
	colSpan,
	text = "No results.",
	className = "",
	rowclassName = "",
}) => (
	<TableRow className={rowclassName}>
		<TableCell
			colSpan={colSpan}
			className={`text-center text-base text-muted-foreground py-8 font-medium ${className}`}
		>
			{text}
		</TableCell>
	</TableRow>
);
